import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../../utils/api';
import { forIn, has, isArray } from 'lodash';

const USER_PAPERLESS = 'USER_PAPERLESS';
const UPDATE_PAPERLESS_FULFILLED = 'UPDATE_PAPERLESS_FULFILLED';
const UPDATE_USER_PAPERLESS_FULFILLED = 'UPDATE_USER_PAPERLESS_FULFILLED';
const USER_PAPERLESS_CLICK_FULFILLED = 'USER_PAPERLESS_CLICK_FULFILLED';
const PAPERLESS_TERMS_CONDITION = 'PAPERLESS_TERMS_CONDITION';

const getPaperlessSettingsByProduct = (paperless) => {
  let subscriptions = [];
  const paperlessMap = {};

  if (
    isArray(paperless) &&
    paperless.length > 0 &&
    has(paperless[0], 'subscriptions')
  ) {
    subscriptions = paperless[0].subscriptions;
  }

  const communicationsFactory = (paperlessData) => {
    const paperlessSettings = {};
    forIn(paperlessData, (value, key) => {
      if (key !== 'productType') {
        paperlessSettings[key] = value;
      }
    });
    return paperlessSettings;
  };

  subscriptions.forEach((product) => {
    paperlessMap[product.productType] = communicationsFactory(product);
  });

  return paperlessMap;
};

export default function paperlessSetting(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    error: null,
    paperless: [],
    paperlessByProductType: {},
    updatedPaperless: false,
    userInteraction: false,
    termsAndConditions: null,
  },
  { payload, type }
) {
  switch (type) {
    case `${USER_PAPERLESS}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${USER_PAPERLESS}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        paperless: [payload.body],
        paperlessByProductType: getPaperlessSettingsByProduct([payload.body]),
      };
    case `${USER_PAPERLESS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasError: true,
        error: payload,
      };

    case `${PAPERLESS_TERMS_CONDITION}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${PAPERLESS_TERMS_CONDITION}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        termsAndConditions:
          payload.body?.[':items'].root?.[':items'].contentfragment.elements
            .main.value,
      };
    case `${PAPERLESS_TERMS_CONDITION}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasError: true,
        error: payload,
      };
    case `${UPDATE_PAPERLESS_FULFILLED}`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        updatedPaperless: payload,
      };
    case `${USER_PAPERLESS_CLICK_FULFILLED}`:
      return {
        ...state,
        userInteraction: true,
      };
    default:
      return state;
  }
}

export const updatePaperlessSetting = (bool) => (dispatch) => {
  const action = createAction(UPDATE_PAPERLESS_FULFILLED)(bool);
  dispatch(action);
};

export const updateUserPaperlessSettings = () => {
  // edelivery is purposefully wrong casing to match backend (whomp)
  const updatePaperlessBody = {
    edeliveryOptions: [
      {
        serviceType: {
          enumerationID: 6,
          enumerationName: 'ECOMPLIANCE',
        },
        subscribed: true,
      },
      {
        serviceType: {
          enumerationID: 8,
          enumerationName: 'PAPERLESS',
        },
        subscribed: true,
      },
      {
        serviceType: {
          enumerationID: 70,
          enumerationName: 'CONFIRMATION',
        },
        subscribed: true,
      },
      {
        serviceType: {
          enumerationID: 97,
          enumerationName: 'MUTUAL_FUND_E_PROXY',
        },
        subscribed: true,
      },
    ],
  };

  return (dispatch) => {
    const action = createAction(UPDATE_USER_PAPERLESS_FULFILLED)(
      callApi(
        `${getEndpoint('paperlessSubscription')}/update`,
        { method: 'PUT' },
        JSON.stringify(updatePaperlessBody)
      )
    );
    dispatch(action);
  };
};

export const paperlessInteraction = () => (dispatch) => {
  const action = createAction(USER_PAPERLESS_CLICK_FULFILLED)(null);
  dispatch(action);
};

export const getUserPaperlessSetting = () => {
  return () => {
    return createAction(USER_PAPERLESS)(
      callApi(getEndpoint('paperlessSubscription'))
    );
  };
};

export const getPaperlessTermsAndConditons = () => (dispatch) => {
  try {
    const action = createAction(PAPERLESS_TERMS_CONDITION)(
      callApi(getEndpoint('paperlessTermsAndConditions', {}, true)).catch(
        (error) => console.error(error)
      )
    );
    dispatch(action).catch((error) => {
      console.error(error);
    });
  } catch (error) {
    console.error(error);
  }
};
